// Third-party
import React from 'react';

// Components
import { Button } from '@/views/components/buttons';

// Utils
import { FormattedMessage } from '@/utils/i18n';

type Props = {
  onChangeTemplate: () => void;
  onSaveComparison: () => void;
  refreshTemplate: () => void;
};

const MoreOptionsSection = ({ onChangeTemplate, onSaveComparison, refreshTemplate }: Props) => (
  <div>
    <div className="mobile-menu-more-options-title">
      <FormattedMessage id="Proposal.Tabs.Options.MoreOptions" />
    </div>
    <div className="mobile-menu-more-options">
      <Button className="change-template-button" onClick={onChangeTemplate}>
        <FormattedMessage id="Proposal.Tabs.Options.ChangeTemplate" />
      </Button>
      <hr />
      <Button className="reload-template-button" onClick={refreshTemplate}>
        <FormattedMessage id="Proposal.Reload" />
      </Button>
      <hr />
      <Button className="save-template-button" onClick={onSaveComparison}>
        <FormattedMessage id="Common.Save" />
      </Button>
    </div>
  </div>
);

export default MoreOptionsSection;
